import type { Nullish } from "~/@types/generics"
import {
  OPTION_AMOUNT,
  OPTION_CONFORT,
  OPTION_SIZE,
  type EVERY_OPTIONS_WITHOUT_COLOR,
} from "~/components/ui/Product/ProductHeader/_data/constants"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

export type TOptionsName = (typeof EVERY_OPTIONS_WITHOUT_COLOR)[number]

export default function useOptionsTranslate(option: Nullish<TOptionsName>) {
  const t = useTranslate()

  switch (option) {
    case OPTION_SIZE:
      return t("product_details_sizes")

    case OPTION_CONFORT:
      return t("product_details_confort")

    case OPTION_AMOUNT:
      return t("product_details_amount")

    default:
      return t("product_details_sizes")
  }
}
